import { render, staticRenderFns } from "./RoomInfomation.vue?vue&type=template&id=2ddb2c01&scoped=true"
import script from "./RoomInfomation.vue?vue&type=script&lang=js"
export * from "./RoomInfomation.vue?vue&type=script&lang=js"
import style0 from "./RoomInfomation.vue?vue&type=style&index=0&id=2ddb2c01&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddb2c01",
  null
  
)

export default component.exports